/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class ChattemplatesDialog extends NoboxEntityDialog<ChattemplatesRow, any> {
        protected getFormKey() { return ChattemplatesForm.formKey; }
        protected getIdProperty() { return ChattemplatesRow.idProperty; }
        protected getLocalTextPrefix() { return ChattemplatesRow.localTextPrefix; }
        protected getNameProperty() { return ChattemplatesRow.nameProperty; }
        protected getService() { return ChattemplatesService.baseUrl; }
        protected getDeletePermission() { return ChattemplatesRow.deletePermission; }
        protected getInsertPermission() { return ChattemplatesRow.insertPermission; }
        protected getUpdatePermission() { return ChattemplatesRow.updatePermission; }

        protected form = new ChattemplatesForm(this.idPrefix);
        constructor() {
            super();
            var initFile = false;
            this.form.Files.element.parent().find("ul").on("DOMNodeInserted", function () {
                if (initFile == false) {
                    initFile = true;
                    $('ul li.file-item.file-image').each(function () {
                        var elIMage = $(this).find(".thumb ");
                        $(this).find(".thumb ").removeAttr("style");
                        $(this).find(".thumb ").css("overflow", "hidden");
                        var image = elIMage.attr("href");
                        elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                    });
                    initFile = false;
                }
            });
        }
        protected updateInterface() {
            super.updateInterface();
            var $form = this.form;
            if (this.isNewOrDeleted()) {
                $form.In.element.closest('.category').toggle(false);
            } else {
                $form.In.element.closest('.category').toggle(true);
            }
        }
    }
}